(function() {
  'use strict';
  
  // State
  let hasScrolled = false;
  let bannerShown = false;
  let scrollTimer = null;
  let delayTimer = null;
  
  // Get configuration from data attributes
  function getConfig() {
    const banner = document.getElementById('smartBanner');
    if (!banner) return null;
    
    return {
      iosUrl: banner.dataset.iosUrl || '',
      androidUrl: banner.dataset.androidUrl || '',
      scrollThreshold: parseInt(banner.dataset.scrollThreshold, 10) || 100,
      initialDelay: parseInt(banner.dataset.initialDelay, 10) * 1000 || 3000,
      dismissalDays: parseInt(banner.dataset.dismissalDays, 10) || 7,
      excludePages: (banner.dataset.excludePages || '').split(',').map(p => p.trim()).filter(Boolean),
      inAppIdentifiers: (banner.dataset.inAppIdentifiers || '').split(',').map(i => i.trim()).filter(Boolean)
    };
  }
  
  // Check if we're in a mobile app webview
  function isInApp(identifiers) {
    const userAgent = navigator.userAgent.toLowerCase();
    
    // Common in-app browser indicators
    const commonInAppBrowsers = [
      'instagram',
      'fbav',
      'fban',
      'fb_iab',
      'twitter',
      'linkedin',
      'pinterest',
      'telegram',
      'snapchat',
      'whatsapp',
      'line',
      'kakaotalk',
      'reddit'
    ];
    
    // Check custom identifiers
    if (identifiers && identifiers.length > 0) {
      if (identifiers.some(id => userAgent.includes(id.toLowerCase()))) {
        return true;
      }
    }
    
    // Check common in-app browsers
    return commonInAppBrowsers.some(browser => userAgent.includes(browser));
  }
  
  // Check if device is mobile
  function isMobile() {
    return window.innerWidth < 750; // Match Shopify's mobile breakpoint
  }
  
  // Check if we're on an excluded page
  function isExcludedPage(excludePages) {
    if (!excludePages || excludePages.length === 0) return false;
    
    const currentPath = window.location.pathname;
    return excludePages.some(page => {
      if (page.startsWith('/')) {
        return currentPath.startsWith(page);
      }
      return currentPath.includes(page);
    });
  }
  
  // Check if banner was recently dismissed
  function wasBannerRecentlyDismissed(dismissalDays) {
    const dismissedTime = localStorage.getItem('smartBannerDismissed');
    if (!dismissedTime) return false;
    
    const now = Date.now();
    const timeSinceDismissal = now - parseInt(dismissedTime, 10);
    const dismissalDuration = dismissalDays * 24 * 60 * 60 * 1000;
    return timeSinceDismissal < dismissalDuration;
  }
  
  // Detect platform and get app store link
  function getAppStoreLink(config) {
    if (!config.iosUrl && !config.androidUrl) return null;
    
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    if (isIOS && config.iosUrl) {
      return config.iosUrl;
    } else if (!isIOS && config.androidUrl) {
      return config.androidUrl;
    } else if (config.iosUrl) {
      // Fallback to iOS URL if Android URL not provided
      return config.iosUrl;
    } else {
      // Fallback to Android URL if iOS URL not provided
      return config.androidUrl;
    }
  }
  
  // Show the smart banner
  function showSmartBanner() {
    const config = getConfig();
    if (!config) {
      console.log('Smart Banner: No config found');
      return;
    }
    
    // Debug logging
    if (window.location.search.includes('debug-banner')) {
      console.log('Smart Banner Debug:', {
        bannerShown,
        isMobile: isMobile(),
        isInApp: isInApp(config.inAppIdentifiers),
        isExcludedPage: isExcludedPage(config.excludePages),
        wasDismissed: wasBannerRecentlyDismissed(config.dismissalDays),
        config
      });
    }
    
    if (bannerShown || 
        !isMobile() || 
        isInApp(config.inAppIdentifiers) || 
        isExcludedPage(config.excludePages) ||
        wasBannerRecentlyDismissed(config.dismissalDays)) {
      return;
    }
    
    const banner = document.getElementById('smartBanner');
    const link = document.getElementById('smartBannerLink');
    
    if (banner && link) {
      const appStoreLink = getAppStoreLink(config);
      if (!appStoreLink) {
        console.warn('Smart Banner: No app store URLs configured');
        return;
      }
      
      link.href = appStoreLink;
      banner.style.display = 'flex';
      bannerShown = true;
    }
  }
  
  // Dismiss the smart banner
  window.dismissSmartBanner = function() {
    const banner = document.getElementById('smartBanner');
    if (banner) {
      banner.style.display = 'none';
      localStorage.setItem('smartBannerDismissed', Date.now().toString());
      
      // Clean up timers
      if (scrollTimer) {
        cancelAnimationFrame(scrollTimer);
        scrollTimer = null;
      }
      if (delayTimer) {
        clearTimeout(delayTimer);
        delayTimer = null;
      }
    }
  };
  
  // Handle scroll event with debouncing
  function handleScroll() {
    const config = getConfig();
    if (!config || hasScrolled) return;
    
    if (scrollTimer) {
      cancelAnimationFrame(scrollTimer);
    }
    
    scrollTimer = requestAnimationFrame(function() {
      if (window.scrollY > config.scrollThreshold) {
        hasScrolled = true;
        showSmartBanner();
      }
    });
  }
  
  // Handle window resize
  function handleResize() {
    const banner = document.getElementById('smartBanner');
    if (!banner) return;
    
    if (!isMobile()) {
      banner.style.display = 'none';
    } else if (bannerShown) {
      const config = getConfig();
      if (config && !wasBannerRecentlyDismissed(config.dismissalDays)) {
        banner.style.display = 'flex';
      }
    }
  }
  
  // Initialize
  function init() {
    const config = getConfig();
    if (!config) return;
    
    // Don't initialize if not on mobile or in app
    if (!isMobile() || isInApp(config.inAppIdentifiers) || isExcludedPage(config.excludePages)) {
      return;
    }
    
    // Add scroll listener with passive flag for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Show after delay if configured and no scroll
    if (config.initialDelay > 0) {
      delayTimer = setTimeout(function() {
        if (!hasScrolled) {
          showSmartBanner();
        }
      }, config.initialDelay);
    }
    
    // Handle window resize with debouncing
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 150);
    });
    
    // Handle visibility change (e.g., tab switching)
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'visible' && !bannerShown) {
        // Re-check conditions when tab becomes visible
        const config = getConfig();
        if (config && isMobile() && !isInApp(config.inAppIdentifiers) && 
            !isExcludedPage(config.excludePages) && !wasBannerRecentlyDismissed(config.dismissalDays)) {
          if (hasScrolled || window.scrollY > config.scrollThreshold) {
            showSmartBanner();
          }
        }
      }
    });
  }
  
  // Clean up on page unload
  window.addEventListener('beforeunload', function() {
    if (scrollTimer) {
      cancelAnimationFrame(scrollTimer);
    }
    if (delayTimer) {
      clearTimeout(delayTimer);
    }
  });
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Desktop QR Code functionality
  let desktopScrolled = false;
  let desktopBannerShown = false;
  let desktopScrollTimer = null;
  let desktopDelayTimer = null;
  
  // Get desktop configuration
  function getDesktopConfig() {
    const banner = document.getElementById('smartBannerDesktop');
    if (!banner) return null;
    
    return {
      hasQr: banner.dataset.hasQr === 'true',
      position: banner.dataset.position || 'bottom-right',
      animation: banner.dataset.animation || 'slide-up',
      scrollThreshold: parseInt(banner.dataset.desktopScroll, 10) || 300,
      initialDelay: parseInt(banner.dataset.desktopDelay, 10) * 1000 || 10000,
      dismissalDays: parseInt(banner.dataset.desktopDismissal, 10) || 14
    };
  }
  
  // Check if device is desktop
  function isDesktop() {
    return window.innerWidth >= 750;
  }
  
  // Check if desktop banner was recently dismissed
  function wasDesktopBannerRecentlyDismissed(dismissalDays) {
    const dismissedTime = localStorage.getItem('smartBannerDesktopDismissed');
    if (!dismissedTime) return false;
    
    const now = Date.now();
    const timeSinceDismissal = now - parseInt(dismissedTime, 10);
    const dismissalDuration = dismissalDays * 24 * 60 * 60 * 1000;
    return timeSinceDismissal < dismissalDuration;
  }
  
  
  // Show desktop banner
  function showDesktopBanner() {
    const config = getDesktopConfig();
    if (!config || !config.hasQr) return;
    
    if (desktopBannerShown || 
        !isDesktop() || 
        wasDesktopBannerRecentlyDismissed(config.dismissalDays)) {
      return;
    }
    
    const banner = document.getElementById('smartBannerDesktop');
    if (banner) {
      banner.style.display = 'block';
      desktopBannerShown = true;
    }
  }
  
  // Dismiss desktop banner
  window.dismissDesktopBanner = function() {
    const banner = document.getElementById('smartBannerDesktop');
    if (banner) {
      banner.style.display = 'none';
      localStorage.setItem('smartBannerDesktopDismissed', Date.now().toString());
      
      // Clean up timers
      if (desktopScrollTimer) {
        cancelAnimationFrame(desktopScrollTimer);
        desktopScrollTimer = null;
      }
      if (desktopDelayTimer) {
        clearTimeout(desktopDelayTimer);
        desktopDelayTimer = null;
      }
    }
  };
  
  // Handle desktop scroll
  function handleDesktopScroll() {
    const config = getDesktopConfig();
    if (!config || desktopScrolled || !isDesktop()) return;
    
    if (desktopScrollTimer) {
      cancelAnimationFrame(desktopScrollTimer);
    }
    
    desktopScrollTimer = requestAnimationFrame(function() {
      if (window.scrollY > config.scrollThreshold) {
        desktopScrolled = true;
        showDesktopBanner();
      }
    });
  }
  
  // Handle desktop resize
  function handleDesktopResize() {
    const banner = document.getElementById('smartBannerDesktop');
    if (!banner) return;
    
    if (!isDesktop()) {
      banner.style.display = 'none';
    } else if (desktopBannerShown) {
      const config = getDesktopConfig();
      if (config && !wasDesktopBannerRecentlyDismissed(config.dismissalDays)) {
        banner.style.display = 'block';
      }
    }
  }
  
  // Initialize desktop functionality
  function initDesktop() {
    const config = getDesktopConfig();
    if (!config || !isDesktop()) return;
    
    // Check if on excluded page
    const excludePages = (document.getElementById('smartBanner')?.dataset.excludePages || '').split(',').map(p => p.trim()).filter(Boolean);
    if (isExcludedPage(excludePages)) return;
    
    // Add desktop scroll listener
    window.addEventListener('scroll', handleDesktopScroll, { passive: true });
    
    // Show after delay if configured
    if (config.initialDelay > 0) {
      desktopDelayTimer = setTimeout(function() {
        if (!desktopScrolled) {
          showDesktopBanner();
        }
      }, config.initialDelay);
    }
    
    // Handle window resize for desktop
    let desktopResizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(desktopResizeTimer);
      desktopResizeTimer = setTimeout(handleDesktopResize, 150);
    });
  }
  
  // Initialize desktop when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktop);
  } else {
    initDesktop();
  }
})();